
import { prefixedColour, invertColor, padZero } from "../../apps/lib/utils"

import { BusinessProvider, BusinessContext } from '@/apps/providers/BusinessContext';
import { CartProvider } from '@/apps/providers/CartContext';
import { UserProvider } from '@/apps/providers/UserContext';
import { ChatProvider } from '@/apps/components/chat';
import { ChatWidget } from '@/apps/components/chat';

import { getFromApi } from "@/apps/lib/api"


const isEmpty = (str) => {
  return str == null || str == ""
}

const twitterButton = (business) => {
  if (isEmpty(business.twitter)) return <></>

  if (business.twitter.startsWith("https")) {
    return (
      <a href={business.twitter}>
        <span className="social-button" >
          <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }
  return (
    <a href={"https://twitter.com/" + business.twitter}>
      <span className="social-button" >
        <i className="zmdi zmdi-twitter" style={{ fontSize: 30 }}></i>
      </span>
    </a>
  )
}

const facebookButton = (business) => {
  if (isEmpty(business.facebook)) return <></>
  if (business.facebook.startsWith("https")) {
    return (
      <a href={business.facebook}>
        <span className="social-button" >
          <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }
  return (
    <a href={"https://facebook.com/" + business.facebook}>
      <span className="social-button" >
        <i className="zmdi zmdi-facebook" style={{ fontSize: 30 }}></i>
      </span>
    </a>
  )
}

const whatsappButton = (business) => {
  if (isEmpty(business.whatsapp)) return <></>

  let phone = business.whatsapp
  if (phone.startsWith('+')) phone = phone.slice(1)

  return (
    <a href={"https://wa.me/" + phone}>
      <span className="social-button" >
        <i className="zmdi zmdi-whatsapp" style={{ fontSize: 30 }}></i>
      </span>
    </a>
  )
}

const instagramButton = (business) => {
  if (isEmpty(business.instagram)) return <></>
  if (business.instagram.startsWith("https")) {
    return (
      <a href={business.instagram}>
        <span className="social-button" >
          <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
        </span>
      </a>
    )
  }
  return (
    <a href={"https://instagram.com/" + business.instagram}>
      <span className="social-button" >
        <i className="zmdi zmdi-instagram" style={{ fontSize: 30 }}></i>
      </span>
    </a>
  )
}

const youtubeButton = (business) => {
  if (isEmpty(business.youtube)) return <></>
  if (business.youtube.startsWith("https")) {
    return (
      <a href={business.youtube}>
        <span className="social-button" >
          <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
        </span>
      </a>

    )
  }
  return (
    <a href={"https://youtube.com/" + business.youtube}>
      <span className="social-button" >
        <i className="zmdi zmdi-youtube" style={{ fontSize: 30 }}></i>
      </span>
    </a>
  )

}

const contentForLink = (link) => {
  if (link.photo != "") {
    return <img src={link.photo} style={{ maxHeight: 80, marginBottom: '0.5rem' }} />
  }

  return <h2><div className="button centered v-centered br-15 styled-button">{link.title}</div></h2>
}


function NewLandingPage() {

  const [domain, setDomain] = React.useState(null)
  const [products, setProducts] = React.useState([])
  const [menus, setMenus] = React.useState([])
  const [menuCity, setMenuCity] = React.useState(null)

  React.useEffect(() => {

    let business = window.business
    let menus = window.menus || [{}]
    menus = menus.filter((m) => m.enabled == true)

    menus.sort((a, b) => a.Location.city.localeCompare(b.Location.city))

    setMenus(menus)

    if (business) {

      // get the products for the business if assets are empty
      setDomain(business.uuid.toLowerCase())

      if (business.Assets.length == 0) {
        let path = `/api/v1/business/${business.id}/products`

        getFromApi(
          path, {}, (data) => {
            //console.log("got products", data.result)
            let products = data.result.filter((p) => p.photo != "" && p.photo != business.photo)

            if (products.length > 5) {
              setProducts(products.slice(0, 5))
            } else {
              setProducts(products)
            }
          }, (error) => {
            console.log("Error", error)
          }
        )

      }


      let css = document.createElement('style');

      css.innerHTML = `
      body {
        background-color: #000000;
        color: #ffffff;
      }
  .home-container {
        background-color: #000000;
        color: #ffffff;
      }
       .home-container .social-button i {
      color: #ffffff;
    }
    `;


      if (business.style && business.style != "") {
        css.innerHTML = business.style
      } else if (business.colour && business.colour != "") {
        let style = {
          backgroundColor: prefixedColour(business.colour),
          color: invertColor(business.colour, true)
        }
        css.innerHTML = `
        body {
          background-color: ${style.backgroundColor};
          color: ${style.color};
        }
        .home-container {
      background-color: ${style.backgroundColor};
      color: ${style.color};
    }
    .home-container .social-button i {
      color: ${style.color};
    }
  `;
      }

      //console.log("style", css.innerHTML)

      document.head.appendChild(css);

    }

  }, [])


  React.useEffect(() => {
    //console.log("Detail carouselImages useEffect")
    // initiate Owl carousel
    if (carouselImages != null) {
      $(".owl-carousel").owlCarousel(
        {
          responsive: {
            0: {
              items: 1,
            },
            600: {
              items: 1,
            },
            1000: {
              items: 2,
            },
            1200: {
              items: 3,
            },
          },
          items: carouselImages.length,
          lazyLoad: true,
          pagination: "false",
          loop: true,
          center: true,
          dots: true,
          loop: true,
          //margin: 10,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          nav: false,
          navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
        }

      );
    }
  },);

  const assetsRow = () => {

    if (business.Assets && business.Assets.length > 1) {
      // return a carousel with the assets
      return (
        <div className="LandingPage-assets-row ">
          <div className=" centered">
            <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
              {business.Assets.map((a, index) => {
                return (
                  <div className="item centered" key={`carouselImg_${index}`}>
                    <img src={a.url} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </div>
          </div>
        </div>
      )
    } else if (products.length > 0) {
      // return the asset image
      return (
        <div className="LandingPage-products-row ">
          <div className=" centered">
            <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
              {products.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.photo} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </div>
          </div>
        </div>
      )
    } else if (business.banner && business.banner != "") {
      // return the business banner
      return (
        <div className=" logo-row">
          <div className=" centered"><img src={business.banner} style={{
            maxHeight: 200,
            minHeight: 100,
            maxWidth: 500,
            objectFit: 'cover'
          }} /></div>
        </div>
      )
    }

    return <></>

  }

  const slugUrl = (uuid) => {
    //console.log("slug url", window.location.href)

    if (window.location.href.includes("localhost")) {
      return `http://localhost:3008/m/${domain}/${uuid}`
    }
    return `https://${domain}.zono.cc/${uuid}`
  }

  const appUrl = (page) => {
    if (window.location.href.includes("localhost")) {
      return `http://localhost:3008/page/${business.uuid}/${page}`
    }
    return `https://app.zono.cc/page/${business.uuid}/${page}`
  }




  //console.log("business", business)

  const linkOrImageButton = (menu, link, name) => {
    if (menu.button == "") {
      return (

        <div className="menu-link-row nofollow centered mw98" key={`menu_${menu.id}`} >
          <a rel="nofollow" href={link}>
            <h2 className="w95"><div className="button centered v-centered br-8 styled-button">{name}</div></h2>
          </a>

        </div>

      )
    }
    return (
      <div className="menu-link-row nofollow centered " key={`menu_${menu.id}`} >
        <a rel="nofollow" href={link}>
          <img src={menu.button} style={{ maxHeight: 80, marginBottom: '0.5rem' }} />
        </a>

      </div>
    )
  }

  const communityLinks = () => {

    if (window.communityCount == 0 &&
      window.eventCount == 0 &&
      window.offersCount == 0
    ) return <></>

    if (business && business.flags && business.flags.includes("community")) {
      return (<div className="centered my-2">

        <div className="row"  >
          <div className="col v-centered centered py-2"
            onClick={() => window.location.href = appUrl("offers")}
          >
            <span className="material-symbols-outlined md-36">
              grade
            </span>

            <span>Beneficios</span>
          </div>
          <div className="col v-centered centered py-2"
            onClick={() => window.location.href = appUrl("community")}
          >
            <span className="material-symbols-outlined md-36">
              groups
            </span>
            <span>Comunidad</span>
          </div>

        </div>

      </div>)
    }

    return <></>
  }

  const menuButton = (menu) => {

    let name = menu.linkTitle

    if (name == "") {
      let parts = [menu.name, menu.Location.city]

      // if there is only 1 location no need to show the city
      if (menu.name == menu.Location.city || menus.length == 1) {
        parts.pop()
      }
      name = parts.filter((p) => p && p != '').join(' - ')

      //console.log("parts", name, parts, m.name, m.Location.city)
    }

    if (menu.Location.uuid != "") {
      return linkOrImageButton(menu, slugUrl(menu.Location.uuid), name)
    }

    // location uuid is blank so go directly to the menu using business, location and menu IDs
    return (

      <div className="menu-link-row nofollow centered mw98" key={`menu_${menu.id}`} >
        <a rel="nofollow" href={`https://zono.cc/?bid=${menu.business_id}&lid=${menu.location_id}&mid=${menu.id}`}>
          <h2 className="w95"><div className="buttoncentered v-centered br-8 styled-button">{name}</div></h2>
        </a>
      </div>

    )
  }

  // if the business has the flag collapsedMenus, show the menus in a collapsed way
  // organised by city
  const collapsedMenus = () => {
    if (business && business.flags && business.flags.includes("collapsedMenus")) {

      // if menuCity is null then show the menus by city
      if (menuCity == null) {
        // create a button for each city
        let cities = new Set(menus.map((m) => m.Location.city).filter((c) => c && c != ''))

        console.log("cities", cities)
        cities = Array.from(cities).sort()
        console.log("cities", cities)

        return (
          <div className="LandingPage-collapsed-menus">
            {cities.map((c) => {
              return (
                <div className="LandingPage-collapsed-menu-container centered" key={`city_${c}`} onClick={() => setMenuCity(c)}>
                  <h2 className="w95"><div className="button centered v-centered LandingPage-collapsed-menu-button br-8 mb-2">{c}</div></h2>
                </div>

              )
            })}

          </div>
        )
      } else {
        // show the menus for the current city
        return (
          <div className="LandingPage-collapsed-menus">
            {menus.filter((m) => m.Location.city == menuCity).map((m) => {
              return menuButton(m)
            })}
          </div>
        )
      }
    }
    return (
      <div className="LandingPage-menu-links collapsedMenus-menus">

        {menus.map((m) => {
          return menuButton(m)
        }

        )}
      </div>
    )
  }

  const menusAndLinks = () => {
    if (business && business.flags && business.flags.includes("linksFirst")) {
      return (
        <>

          {business.Links && business.Links.map((m) => {

            return (

              <div className="menu-link-row centered mw98" key={`menu_${m.id}`} >
                <a href={m.link}>
                  {contentForLink(m)}
                </a>
              </div>

            )
          })}

          {collapsedMenus()}

        </>
      )
    }
    return (
      <>

        {collapsedMenus()}

        {business.Links && business.Links.map((m) => {

          return (

            <div className="menu-link-row nofollow centered mw98" key={`menu_${m.id}`} >
              <a rel="nofollow" href={m.link}>
                {contentForLink(m)}
              </a>
            </div>

          )
        })}
      </>
    )
  }

  //console.log("business", business)

  return (

    <div className="menu-container business-container"  >
      <div className="row logo-row pt-3"   >
        <div className="col centered"><img src={business.photo} width={250} /></div>
      </div>

      {assetsRow()}

      <div className="row"  >
        <div className="col centered"><span>{business.description}</span></div>
      </div>

      {communityLinks()}

      {menusAndLinks()}


      <div className="centered">
        <div className="social-row  ">
          <div>
            &nbsp;

          </div>
          <div>
            {twitterButton(business)}
            {facebookButton(business)}
            {whatsappButton(business)}
            {instagramButton(business)}
            {youtubeButton(business)}
          </div>
          <div>
            &nbsp;
          </div>

        </div>
      </div>

      <div className="row  powered-row">
        <div className="col centered"><span>Powered By</span></div>
      </div>

      <div className="row logo-row">
        <a href="https://zono.cc" target="blank">
          <div className="col centered"><img src="/images/zono-smile.png" width={100} /></div>
        </a>
      </div>

    </div>
  )
}

function NewChatPage() {

  const [domain, setDomain] = React.useState(null)
  const [menus, setMenus] = React.useState([])
  const [menuCity, setMenuCity] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [business, setBusiness] = React.useState(null)
  const { setSelectedBusiness, setSelectedMenu, selectedMenu, getBusinessForID, getMenuForID, getMenusForBusiness } = React.useContext(BusinessContext)

  React.useEffect(() => {

    // Helper function to parse URL query parameters
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search)
      return {
        bid: params.get('bid'),
        lid: params.get('lid'),
        mid: params.get('mid'),
        uuid: params.get('uuid')
      }
    }

    const params = getQueryParams()

    // If query parameters exist, fetch from API
    if (params.bid || params.uuid || params.mid) {
      setLoading(true)

      // Fetch business data first
      const businessId = params.bid || params.uuid
      getBusinessForID(businessId, (bizData) => {
        if (bizData) {
          setBusiness(bizData)
          setDomain(bizData.uuid.toLowerCase())

          // Apply styles
          let css = document.createElement('style');
          if (bizData.style && bizData.style != "") {
            css.innerHTML = bizData.style
          } else if (bizData.colour && bizData.colour != "") {
            let style = {
              backgroundColor: prefixedColour(bizData.colour),
              color: invertColor(bizData.colour, true)
            }
            css.innerHTML = `
              body {
                background-color: ${style.backgroundColor};
                color: ${style.color};
              }
              .home-container {
                background-color: ${style.backgroundColor};
                color: ${style.color};
              }
              .home-container .social-button i {
                color: ${style.color};
              }
            `;
          }
          document.head.appendChild(css)
        }

        // Fetch menu if mid is provided
        if (params.mid) {
          getMenuForID(params.mid, (menuData) => {
            setLoading(false)
          })
        } else {
          // Otherwise fetch all menus for the business
          getMenusForBusiness(businessId, (menusData) => {
            if (menusData && menusData.length > 0) {
              const enabledMenus = menusData.filter(m => m.enabled == true)
              enabledMenus.sort((a, b) => a.Location.city.localeCompare(b.Location.city))
              setMenus(enabledMenus)

              // Select first menu if only one
              if (enabledMenus.length === 1) {
                setSelectedMenu(enabledMenus[0])
              }
            }
            setLoading(false)
          })
        }
      })
    } else {
      // Fall back to window globals for backward compatibility
      let windowBusiness = window.business
      let menu = window.menu
      let windowMenus = window.menus || [{}]
      windowMenus = windowMenus.filter((m) => m.enabled == true)

      windowMenus.sort((a, b) => {
        return a.Location.city.localeCompare(b.Location.city)
      })

      setMenus(windowMenus)
      setBusiness(windowBusiness)

      // Initialize BusinessContext with business and menu data
      if (windowBusiness) {
        setSelectedBusiness(windowBusiness)
        setDomain(windowBusiness.uuid.toLowerCase())

        let css = document.createElement('style');
        css.innerHTML = `
          body {
            background-color: #000000;
            color: #ffffff;
          }
          .home-container {
            background-color: #000000;
            color: #ffffff;
          }
          .home-container .social-button i {
            color: #ffffff;
          }
        `;

        if (windowBusiness.style && windowBusiness.style != "") {
          css.innerHTML = windowBusiness.style
        } else if (windowBusiness.colour && windowBusiness.colour != "") {
          let style = {
            backgroundColor: prefixedColour(windowBusiness.colour),
            color: invertColor(windowBusiness.colour, true)
          }
          css.innerHTML = `
            body {
              background-color: ${style.backgroundColor};
              color: ${style.color};
            }
            .home-container {
              background-color: ${style.backgroundColor};
              color: ${style.color};
            }
            .home-container .social-button i {
              color: ${style.color};
            }
          `;
        }
        document.head.appendChild(css)
      }

      if (menu) {
        setSelectedMenu(menu)
      } else if (windowMenus.length == 1) {
        setSelectedMenu(windowMenus[0])
      }

      setLoading(false)
    }

  }, [getBusinessForID, getMenuForID, getMenusForBusiness, setSelectedBusiness, setSelectedMenu])

  const initSessionForMenu = (menu) => {
    const locationId = localStorage.getItem('chat_session_location_id');
    if (locationId != menu.location_id) {
       localStorage.setItem('chat_session_location_id', menu.location_id);
       localStorage.removeItem("chat_session_id")
    }
    setSelectedMenu(menu)
  }

  //console.log("business", business)

  const linkOrImageButton = (menu, name) => {
    if (menu.button == "") {
      return (

        <div className="menu-link-row nofollow centered mw98" key={`menu_${menu.id}`} onClick={() => initSessionForMenu(menu)} >

          <h2 className="w95"><div className="button centered v-centered br-8 styled-button">{name}</div></h2>

        </div>

      )
    }
    return (
      <div className="menu-link-row nofollow centered " key={`menu_${menu.id}`} onClick={() => initSessionForMenu(menu)} >

        <img src={menu.button} style={{ maxHeight: 80, marginBottom: '0.5rem' }} />


      </div>
    )
  }

  const menuButton = (menu) => {

    let name = menu.linkTitle

    if (name == "") {
      //console.log("set parts with", menu.name, menu.Location)
      let parts = [menu.name, menu.Location.city]

      // if there is only 1 location no need to show the city
      if (menu.name == menu.Location.city || menus.length == 1) {
        parts.pop()
      }
      name = parts.filter((p) => p && p != '').join(' - ')

      //console.log("parts", name, parts, m.name, m.Location.city)
    }

    if (menu.Location.uuid != "") {
      return linkOrImageButton(menu, name)
    }

    // location uuid is blank so go directly to the menu using business, location and menu IDs
    return (

      <div className="menu-link-row nofollow centered mw98" key={`menu_${menu.id}`} onClick={() => initSessionForMenu(menu)} >

        <h2 className="w95"><div className="buttoncentered v-centered br-8 styled-button">{name}</div></h2>

      </div>

    )
  }

  // if the business has the flag collapsedMenus, show the menus in a collapsed way
  // organised by city
  const collapsedMenus = () => {
    if (business && business.flags && business.flags.includes("collapsedMenus")) {

      // if menuCity is null then show the menus by city
      if (menuCity == null) {
        // create a button for each city

        let cities = new Set(menus.map((m) => {
          //console.log("collapsedMenus", m.Location)
          return m.Location.city
        }).filter((c) => c && c != ''))

        //console.log("cities", cities)
        cities = Array.from(cities).sort()
        //console.log("cities", cities)

        return (
          <div className="LandingPage-collapsed-menus">
            {cities.map((c) => {
              return (
                <div className="LandingPage-collapsed-menu-container centered" key={`city_${c}`} onClick={() => setMenuCity(c)}>
                  <h2 className="w95"><div className="button centered v-centered LandingPage-collapsed-menu-button br-8 mb-2">{c}</div></h2>
                </div>

              )
            })}

          </div>
        )
      } else {
        // show the menus for the current city
        return (
          <div className="LandingPage-collapsed-menus">
            {menus.filter((m) => m.Location.city == menuCity).map((m) => {
              return menuButton(m)
            })}
          </div>
        )
      }
    }
    return (
      <div className="LandingPage-menu-links collapsedMenus-menus">

        {menus.map((m) => {
          return menuButton(m)
        }

        )}
      </div>
    )
  }

  const menusAndLinks = () => {
    if (business && business.flags && business.flags.includes("linksFirst")) {
      return (
        <>

          {business.Links && business.Links.map((m) => {

            return (

              <div className="menu-link-row centered mw98" key={`menu_${m.id}`} >
                <a href={m.link}>
                  {contentForLink(m)}
                </a>
              </div>

            )
          })}

          {collapsedMenus()}

        </>
      )
    }
    return (
      <>

        {collapsedMenus()}

        {business.Links && business.Links.map((m) => {

          return (

            <div className="menu-link-row nofollow centered mw98" key={`menu_${m.id}`} >
              <a rel="nofollow" href={m.link}>
                {contentForLink(m)}
              </a>
            </div>

          )
        })}
      </>
    )
  }

  console.log("selectedMenu", selectedMenu)

  // Show loading state
  if (loading) {
    return (
      <div className="menu-container business-container centered" style={{ padding: '50px' }}>
        <div className="centered">
          <h3>Loading...</h3>
        </div>
      </div>
    )
  }

  // Show error state if no business data
  if (!business) {
    return (
      <div className="menu-container business-container centered" style={{ padding: '50px' }}>
        <div className="centered">
          <h3>Business not found</h3>
          <p>Please check the URL and try again.</p>
        </div>
      </div>
    )
  }

  return (

    <div className="menu-container business-container centered"  >
      <div className="row logo-row pt-3"   >
        <div className="col centered"><img src={business.photo} width={250} /></div>
      </div>


      <div className="row"  >
        <div className="col centered"><span>{business.description}</span></div>
      </div>

      {selectedMenu &&
        <div className="centered ">
          <div className="row"  >
            <div className="col centered"><span>{selectedMenu.Location.address}, {selectedMenu.Location.city}</span></div>
          </div>
          <ChatWidget startOpen={true} inLanding={true} />
        </div>
      }

      {!selectedMenu &&
        <div>
          {menusAndLinks()}

          <div className="centered">
            <div className="social-row  ">
              <div>
                &nbsp;

              </div>
              <div>
                {twitterButton(business)}
                {facebookButton(business)}
                {whatsappButton(business)}
                {instagramButton(business)}
                {youtubeButton(business)}
              </div>
              <div>
                &nbsp;
              </div>

            </div>
          </div>

        </div>

      }



      <div className="row  powered-row">
        <div className="col centered"><span>Powered By</span></div>
      </div>

      <div className=" centered ">
        <a href="https://zono.cc" target="blank">
          <div className=" centered"><img src="/images/zono-smile.png" width={100} /></div>
        </a>
      </div>

    </div>
  )
}

document.addEventListener('DOMContentLoaded', function () {

  //LandingPage()

  let container = document.getElementById("business-view");

  if (container) {
    const root = ReactDOM.createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<NewLandingPage />);
  } else {
    let container = document.getElementById("chat-view");

    if (container) {
      const root = ReactDOM.createRoot(container); // createRoot(container!) if you use TypeScript
      root.render(<BusinessProvider>
        <CartProvider>
          <UserProvider>
            <ChatProvider>
              <NewChatPage />
            </ChatProvider>
          </UserProvider>
        </CartProvider>
      </BusinessProvider>);
    }
  }
})
